import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserType } from '../types';

interface PrivateRouteProps {
  children: React.ReactNode;
  requiredType?: UserType;
}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requiredType }) => {
  const { isAuthenticated, user, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredType && user?.user_type !== requiredType) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
